import { useEffect, useRef } from 'react';

export const useEventListener = (
  eventName: string,
  // eslint-disable-next-line @typescript-eslint/ban-types
  handler: Function,
  element: null | Window | HTMLElement = typeof window === 'undefined'
    ? null
    : window
) => {
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  const savedHandler = useRef<Function>(() => {});

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    const isSupported = element && element.addEventListener;

    if (!isSupported) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {};
    }
    const eventListener = (event: Event) => savedHandler.current(event);
    element.addEventListener(eventName, eventListener);

    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
};
